<template lang='pug' src='./form-complimentary-exam.pug'></template>

<script>
export default {
  data: () => {
    return {
      message: '',
      fullname: '',
      LastName: '',
      email: '',
      phone: '',
      dob: '',
      formSubmitted: false
    }
  },
  methods: {
    validateBeforeSubmit () {
      this.$validator.validateAll()
      .then(result => {
        if (result) {
          this.formSubmitted = true
        } else {
          alert('Correct them errors!')
        }
      })
      .catch(() => {
        alert('Correct them errors!')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// form-complimentary-exam.vue?5a2a7439